import { render, staticRenderFns } from "./YearQuantityTable.vue?vue&type=template&id=6dffad3a&scoped=true&"
import script from "./YearQuantityTable.vue?vue&type=script&lang=js&"
export * from "./YearQuantityTable.vue?vue&type=script&lang=js&"
import style0 from "./YearQuantityTable.vue?vue&type=style&index=0&id=6dffad3a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dffad3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
